import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgValidereIcon = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "The Validere™ Logomark",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="325"
    height="176"
    viewBox="0 0 325 176"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M242.361 32.9676C235.211 21.2721 227.381 9.17807 214.426 3.44992C202.003 -2.03909 186.628 -0.877518 175.053 6.2172C170.007 9.30334 165.719 13.5624 162.494 18.5276V18.4934C160.684 21.2835 159.179 24.3241 158.082 27.5811L119.5 141.199C118.799 143.26 115.903 143.26 115.212 141.199C106.783 115.77 76.1218 22.0807 70.8268 7.76596L0 7.76596C11.5405 26.6245 82.6275 143.021 82.6388 143.032C89.7894 154.728 97.6188 166.822 110.574 172.55C122.997 178.039 138.372 176.878 149.947 169.783C154.993 166.697 159.281 162.438 162.506 157.472V157.507C164.316 154.716 165.821 151.676 166.918 148.419L205.488 34.801C206.19 32.7398 209.086 32.7398 209.776 34.801C218.205 60.2304 248.867 153.919 254.162 168.234L325 168.234C313.46 149.364 242.372 32.9562 242.361 32.9562V32.9676Z"
      fill="#1D2C34"
    />
  </svg>
);

const ValidereIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgValidereIcon />
  </BaseIcon>
);

export default ValidereIcon;
